import React, { useState, useEffect } from 'react';
import {
  Box,
  Fade,
  useTheme,
  alpha,
} from '@mui/material';
import {
  ArrowUpward as ArrowUpwardIcon,
} from '@mui/icons-material';


const ScrollToTopButton = () => {
  const theme = useTheme();
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <Fade in={isVisible}>
      <Box
        onClick={scrollToTop}
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          zIndex: 1000,
          width: 44,
          height: 44,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          backgroundColor: alpha(theme.palette.primary.main, 0.9),
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            transform: 'translateY(-3px)',
            boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
          },
          '&:active': {
            transform: 'translateY(0)',
          }
        }}
      >
        <ArrowUpwardIcon sx={{ color: 'white', fontSize: '1.2rem' }} />
      </Box>
    </Fade>
  );
};

export default ScrollToTopButton;

